import { render, staticRenderFns } from "./ModalRequestStatic.vue?vue&type=template&id=8b0581e2&scoped=true"
import script from "./ModalRequestStatic.vue?vue&type=script&lang=js"
export * from "./ModalRequestStatic.vue?vue&type=script&lang=js"
import style0 from "./ModalRequestStatic.vue?vue&type=style&index=0&id=8b0581e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0581e2",
  null
  
)

export default component.exports